export default __webpack_public_path__ + "static/media/sibh.f193ae49.mp3";